import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var _rates;

import { MediaChromeButton } from "./media-chrome-button.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIEvents, MediaUIAttributes } from "./constants.js";
import { nouns } from "./labels/labels.js";
import { getNumericAttr, setNumericAttr } from "./utils/element-utils.js";
import { AttributeTokenList } from "./utils/attribute-token-list.js";
var Attributes = {
  RATES: "rates"
};
var DEFAULT_RATES = [1, 1.2, 1.5, 1.7, 2];
var DEFAULT_RATE = 1;
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <style>\n    :host {\n      min-width: 5ch;\n      padding: var(--media-control-padding, 10px 5px);\n    }\n  </style>\n  <span id=\"container\"></span>\n";

var MediaPlaybackRateButton = /*#__PURE__*/function (_MediaChromeButton) {
  _inherits(MediaPlaybackRateButton, _MediaChromeButton);

  var _super = _createSuper(MediaPlaybackRateButton);

  function MediaPlaybackRateButton() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaPlaybackRateButton);

    _this = _super.call(this, _objectSpread({
      slotTemplate: slotTemplate
    }, options));

    __privateAdd(_assertThisInitialized(_this), _rates, new AttributeTokenList(_assertThisInitialized(_this), Attributes.RATES, {
      defaultValue: DEFAULT_RATES
    }));

    _this.container = _this.shadowRoot.querySelector("#container");
    _this.container.innerHTML = "".concat(DEFAULT_RATE, "x");
    return _this;
  }

  _createClass(MediaPlaybackRateButton, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      _get(_getPrototypeOf(MediaPlaybackRateButton.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);

      if (attrName === Attributes.RATES) {
        __privateGet(this, _rates).value = newValue;
      }

      if (attrName === MediaUIAttributes.MEDIA_PLAYBACK_RATE) {
        var newPlaybackRate = newValue ? +newValue : Number.NaN;
        var playbackRate = !Number.isNaN(newPlaybackRate) ? newPlaybackRate : DEFAULT_RATE;
        this.container.innerHTML = "".concat(playbackRate, "x");
        this.setAttribute("aria-label", nouns.PLAYBACK_RATE({
          playbackRate: playbackRate
        }));
      }
    }
  }, {
    key: "rates",
    get: function get() {
      return __privateGet(this, _rates);
    },
    set: function set(value) {
      if (!value) {
        __privateGet(this, _rates).value = "";
      } else if (Array.isArray(value)) {
        __privateGet(this, _rates).value = value.join(" ");
      }
    }
  }, {
    key: "mediaPlaybackRate",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_PLAYBACK_RATE, DEFAULT_RATE);
    },
    set: function set(value) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_PLAYBACK_RATE, value);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      var _a, _b;

      var availableRates = Array.from(this.rates.values(), function (str) {
        return +str;
      }).sort(function (a, b) {
        return a - b;
      });
      var detail = (_b = (_a = availableRates.find(function (r) {
        return r > _this2.mediaPlaybackRate;
      })) != null ? _a : availableRates[0]) != null ? _b : DEFAULT_RATE;
      var evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_PLAYBACK_RATE_REQUEST, {
        composed: true,
        bubbles: true,
        detail: detail
      });
      this.dispatchEvent(evt);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaPlaybackRateButton), "observedAttributes", this)), [MediaUIAttributes.MEDIA_PLAYBACK_RATE, Attributes.RATES]);
    }
  }]);

  return MediaPlaybackRateButton;
}(MediaChromeButton);

_rates = new WeakMap();

if (!globalThis.customElements.get("media-playback-rate-button")) {
  globalThis.customElements.define("media-playback-rate-button", MediaPlaybackRateButton);
}

var media_playback_rate_button_default = MediaPlaybackRateButton;
export { Attributes, DEFAULT_RATE, DEFAULT_RATES, media_playback_rate_button_default as default };